export default "__VITE_ASSET__zIxt7YJK__"